import { Icon } from "@chakra-ui/react"

export const HandleIcon = (props: any) => (
  <Icon xmlns="http://www.w3.org/2000/svg" opacity="0.5" width="20" height="32" viewBox="0 0 20 32" {...props} >
    <g transform="translate(-420 -430)">
      <rect id="Rectangle_852" width="8" height="8" rx="1.5" transform="translate(420 430)" fill="currentColor" opacity="0.634"/>
      <rect id="Rectangle_853" width="8" height="8" rx="1.5" transform="translate(432 430)" fill="currentColor" opacity="0.634"/>
      <rect id="Rectangle_854" width="8" height="8" rx="1.5" transform="translate(432 442)" fill="currentColor" opacity="0.634"/>
      <rect id="Rectangle_855" width="8" height="8" rx="1.5" transform="translate(420 442)" fill="currentColor" opacity="0.634"/>
      <rect id="Rectangle_856" width="8" height="8" rx="1.5" transform="translate(420 454)" fill="currentColor" opacity="0.634"/>
      <rect id="Rectangle_857" width="8" height="8" rx="1.5" transform="translate(432 454)" fill="currentColor" opacity="0.634"/>
    </g>
  </Icon>
);

